import { Stack } from '@chakra-ui/react';
import FaceliftButton from '@/components/Atoms/FaceliftButton';
import FaceliftText from '@/components/Atoms/FaceliftText';

interface IDrawerFooterProps {
  onApply?: () => void;
  onClear?: () => void;
}

const DrawerFooter: React.FC<IDrawerFooterProps> = ({ onApply, onClear }) => {
  return (
    <Stack width={'100%'} mb={5}>
      <FaceliftButton bg='brand.solid' fontWeight={700} onClick={onApply}>APPLY FILTERS</FaceliftButton>
      <FaceliftButton bg={{ _dark: 'surfaceGrey', _light: 'blueGray' }} onClick={onClear}>
        <FaceliftText color='text.muted' fontWeight={700}>ERASE FILTERS</FaceliftText>
      </FaceliftButton>
    </Stack>
  );
};

export default DrawerFooter;